import React from 'react';

import ButtonLink from 'common/uiV3/Button/ButtonLink';
import UppercaseHeader from 'common/UppercaseHeader';
import nbspLastSpace from 'common/util/nbspLastSpace';
import styles from 'css-module/components/www/_LandingCaseStudyHeading.module.scss';

type Props = {
  title: string;
};

const LandingCaseStudyHeadingText = ({ title }: Props) => {
  return (
    <div className={styles.copy}>
      <UppercaseHeader className={styles.subheading}>Customer story</UppercaseHeader>
      <h1 className={styles.heading}>{nbspLastSpace(title)}</h1>
      <ButtonLink size="large" to="/register">
        Get started
      </ButtonLink>
    </div>
  );
};

export default LandingCaseStudyHeadingText;
